import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pagination.component.html'
})
export class PaginationComponent {
  @Input() total = 0;
  @Input() page = 0;
  @Input() rows = 20;

  @Output() pageChange = new EventEmitter<number>();

  constructor(private readonly translation: TranslationService) {}

  get totalPages(): number {
    return Math.ceil(this.total / this.rows);
  }

  get canShow(): boolean {
    return this.totalPages > 1;
  }

  translate(key: string, replacements: Record<string, number> = {}): string {
    return this.translation.translate(key, replacements);
  }

  goTo(nextPage: number): void {
    if (nextPage < 0 || nextPage >= this.totalPages) {
      return;
    }
    this.pageChange.emit(nextPage);
  }
}
